"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileType = void 0;
var FileType;
(function (FileType) {
    FileType["Csv"] = "CSV";
    // CSV for netsuite
    FileType["Netsuite"] = "Netsuite";
    FileType["Pdf"] = "PDF";
    // CSV for quickbooks
    FileType["Quickbooks"] = "Quickbooks";
    // CSV for xero
    FileType["Xero"] = "Xero";
    FileType["Zip"] = "Zip";
})(FileType = exports.FileType || (exports.FileType = {}));
//# sourceMappingURL=fileType.js.map